export default "__VITE_ASSET__CUDaGS0P__"